import {
    required,
    SimpleForm,
    TextInput,
    usePermissions,
    useResourceContext,
    useTranslate,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { RaCreateView } from "../components/views/RaCreateView";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";

export const ManufacturerCreate = (props) => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const translate = useTranslate();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaCreateView {...props} redirect={"edit"} actions={<ToolbarWithHistory />}>
            <SimpleForm>
                <TextInput
                    label="equip.name"
                    title={translate("equip.name")}
                    source="name"
                    validate={[required()]}
                />
            </SimpleForm>
        </RaCreateView>
    );
};
